import * as React from 'react';

import { Button } from '@coursera/coursera-ui';

import CodeBlockV2 from 'bundles/code-evaluator/components/CodeBlockV2';
import Modal from 'bundles/phoenix/components/Modal';

import _t from 'i18n!nls/widget-simulator';

import 'css!./__styles__/JsonViewerModal';

type Props = {
  name: string;
  title: string;
  json: string;
  maxLines?: number;
  onClose: () => void;
};

const JsonViewerModal = ({ name, title, json, maxLines, onClose }: Props) => {
  return (
    <Modal className="rc-JsonViewerModal" modalName={name} handleClose={onClose}>
      <h3 className="modal-title">{title}</h3>

      <div className="modal-content">
        <CodeBlockV2 readOnly={true} codeLanguage="json" expression={json} maxLines={maxLines} />
      </div>

      <div className="modal-actions">
        <Button type="primary" label={_t('Okay')} onClick={onClose} />
      </div>
    </Modal>
  );
};

JsonViewerModal.defaultProps = {
  maxLines: 20,
};

export default JsonViewerModal;
